import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './authentication.service';
import { from, Observable } from 'rxjs';
import { mergeMap, shareReplay, finalize } from 'rxjs/operators'; // Import shareReplay and finalize
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  // 1. Store the token request observable to share it
  private tokenRequest: Observable<string> = null;

  constructor(private auth: AuthService, private _cookieService: CookieService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // 2. Only call renewTokens if one isn't already in progress
    if (!this.tokenRequest) {
      this.tokenRequest = from(this.auth.renewTokens()).pipe(
        shareReplay(1), // 3. Share the same result with all concurrent requests
        finalize(() => this.tokenRequest = null) // 4. Reset when finished
      );
    }

    return this.tokenRequest.pipe(
      mergeMap(token => {
        let tokenReq;
        if (token && req.url.indexOf('getuserdata') === -1) {
          if (req.url.indexOf('RestResource') === -1) {
            let reqHeader = {
              setHeaders: { 
                Authorization: `Bearer ${token}`, 
                userId: this._cookieService.get('$LoopBackSDK$userId') 
              }
            };
            
            const viewAsInfo = JSON.parse(localStorage.getItem('viewAsInfo'));
            const isViewAsVendor = (viewAsInfo && viewAsInfo.viewAsType === 'Vendor');
            if (isViewAsVendor && viewAsInfo.userSfdcId) {
              reqHeader['setHeaders']['vendoruserid'] = viewAsInfo.userSfdcId;
            }
            tokenReq = req.clone(reqHeader);
          } else {
            tokenReq = req.clone({});
          }
        } else {
          tokenReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }

        if (localStorage.getItem('isLoggedIn') !== 'true') {
          this.auth.logout();
        }

        return next.handle(tokenReq);
      })
    );
  }
}
